import React, {useEffect, useState} from 'react';
import style from './Profile.module.css';
import '../../../index.css'
import {Formik, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import Select from 'react-select'
import cvIcon from './CV.svg';
import cvIconerror from './CVerror.svg';
import {File} from "../Types/FileType";
import {Loading} from "../../../components/Loading/Loading";
import {authAxios, serverConn} from "../../../API/apiRequest";
import {toast, ToastContainer} from "material-react-toastify";

interface RSType {
    eduOptions: Array<{ label: string, value: string }>,
    fields: Array<{ label: string, value: string }>,
    militaryOptions?: Array<{ label: string, value: string }> | null,
    resume: {
        cv: string | null,
        description: string | null,
        edu: string | null,
        field: string | null,
        militaryStatus: string | null,
        socialStatus: string | null,
        specialty: string | null
    }
    socialOptions: Array<{ label: string, value: string }>,
    specialtyOptions: Array<{ label: string, value: string }>
}

function Resume() {
    const [CV, setCV] = useState<File>();
    const [change, setchange] = useState<boolean>(false);
    const [user, setuser] = useState<{
        gender: string,
        name: string
    }>();
    const [Load, setLoad] = useState<boolean>(true)
    const [resumeData, setresumeData] = useState<RSType>()

    function handleSetCV(data: any) {
        if(data.target.files[0].size / 1024 / 1024 < 2.9) {
            let cv = {...data.target.files[0]};
            cv.name = `${user && user.name}-CV`;
            setCV(cv)
        }
    }

    const customStyles = {
        control: () => ({
            backgroundColor: 'rgba(255,255,255,0.5)',
            display: 'flex',
            borderRadius: 25,
        }),
    }
    const ErrorStyles = {
        control: () => ({
            backgroundColor: 'rgba(255,255,255,0.5)',
            display: 'flex',
            borderRadius: 25,
            outline: '1px solid rgb(245, 83, 83)',
        }),
    }
    useEffect(() => {
        setLoad(true);
        let ok = false;
        authAxios.get(`/employee/profile`).then((res) => {
            if(res.status === 200) {
                setuser({name: res.data.name, gender: res.data.gender})
                ok = true;
            }
        }).catch(err => {
            console.log(err)
        })
        authAxios.get(`/employee/resume`).then((res) => {
            if(res.status === 200) {
                setresumeData(res.data);
                ok && setLoad(false)
            }
        }).catch(err => {
            console.log(err)
        })
    }, [])

    function getUrl(url: any) {
        if(url && typeof (url) === "string" && url.includes("http")) {
            window.open(url, '_blank')
        }
    }

    function handleFieldChange(ele: any) {
        serverConn.get(`/config/specialties?field=${ele.value}`).then((res) => {
            if(res.status === 200) {
                let data: RSType = {...resumeData} as RSType;
                data.specialtyOptions = res.data.specialties;
                setresumeData(data);
            }
        })
    }

    return (<>
        {Load ? (<div className={"d-flex justify-content-center"}><Loading/></div>) : (
                <>

                    <ToastContainer
                            closeOnClick={false}
                            autoClose={3000}
                            pauseOnHover
                            newestOnTop
                            hideProgressBar={false}

                            position="bottom-right" rtl/>

                    <div style={{boxSizing: 'border-box'}} className={'container rtl mt-4 animate__animated animate__pulse  ' + style.component}>
                        <div>
                            <h2 className={'text-white my-2'}> السيرة الذاتية</h2>
                        </div>
                        <Formik

                                initialValues={{
                                    field: resumeData ? resumeData.fields.find(ele => ele.value === resumeData.resume.field) : {},
                                    major: resumeData ? resumeData.specialtyOptions.find(ele => ele.value === resumeData.resume.specialty) : {},
                                    education: resumeData ? resumeData.eduOptions.find(ele => ele.value === resumeData.resume.edu) : {},
                                    military: resumeData && resumeData.militaryOptions ? resumeData.militaryOptions.find(ele => ele.value === resumeData.resume.militaryStatus) : {},
                                    socialstatus: resumeData ? resumeData.socialOptions.find(ele => ele.value === resumeData.resume.socialStatus) : {},
                                    desc: resumeData ? resumeData.resume.description : "",
                                    CV: resumeData && resumeData.resume.cv ? resumeData.resume.cv : ""
                                }}
                                validationSchema={Yup.object().shape(
                                        user && user.gender === "ذكر" ? {
                                            field: Yup.object().required('برجاء اختيار المجال'),
                                            major: Yup.object().required('برجاء اختيار التخصص'),
                                            education: Yup.object().required('برجاء اختيار المؤهل'),
                                            military: Yup.object().required('برجاء اختيار موقفك من التجنيد'),
                                            socialstatus: Yup.object().required('برجاء اختيار الحاله الاجتماعية'),
                                           
                                        } : {
                                            field: Yup.object().required('برجاء اختيار المجال'),
                                            major: Yup.object().required('برجاء اختيار التخصص'),
                                            education: Yup.object().required('برجاء اختيار المؤهل'),
                                            socialstatus: Yup.object().required('برجاء اختيار الحاله الاجتماعية'),
                                            
                                        })}
                                onSubmit={(Values: any) => {
                                    let formData = new FormData()
                                    formData.append("cv", Values.CV);
                                    formData.append("description", Values.desc);
                                    formData.append("edu", Values.education.value);
                                    formData.append("field", Values.field.value);
                                    formData.append("social", Values.socialstatus.value);
                                    formData.append("specialty", Values.major.value);
                                    if(user && user.gender === "ذكر") {
                                        formData.append("military", Values.military.value);
                                    }
                                    setLoad(true);
                                    authAxios.post(`/employee/resume`, formData, {
                                        headers: {
                                            'Content-Type': 'multipart/form-data'
                                        }
                                    }).then((res) => {
                                        if(res.status === 200) {
                                            let rsdata: RSType | any = {...resumeData};
                                            rsdata.resume = {
                                                cv: res.data.cv,
                                                description: res.data.description,
                                                edu: res.data.education._id,
                                                field: res.data.field._id,
                                                militaryStatus: res.data.militaryStatus ? res.data.militaryStatus._id : null,
                                                socialStatus: res.data.socialStatus._id,
                                                specialty: res.data.specialty._id
                                            }
                                            setresumeData(rsdata);
                                            setLoad(false)
                                            setchange(false)
                                            toast.success("تم حفظ التعديلات");
                                        }
                                    }).catch(err => {
                                        console.log(err)
                                    })
                                }}

                        >
                            {({
                                  setFieldValue,
                                  setFieldTouched,
                                  values,
                                  errors,
                                  touched,
                              }) => (
                                    <Form>
                                        <div className={'row'}>

                                            <div className={'col-12 col-lg-6 py-2'} style={{boxSizing: 'border-box'}}>
                                                <label className={'text-white mb-2'}>المجال</label>

                                                <Select options={resumeData ? resumeData.fields : []} name={'field'}
                                                        onChange={selectedOption => {
                                                            setchange(true)
                                                            setFieldValue("field", selectedOption)
                                                            handleFieldChange(selectedOption)
                                                        }}
                                                        onFocus={() => {
                                                            setFieldTouched("field")
                                                        }}
                                                        value={values.field}
                                                        styles={errors.field && touched.field ? ErrorStyles : customStyles}
                                                        placeholder={'أختر مجالك'}/>
                                                <ErrorMessage name="field" className={style.TextError} component="div"/>
                                            </div>

                                            <div className={'col-12 col-lg-6 py-2'} style={{boxSizing: 'border-box'}}>
                                                <label className={'text-white mb-2'}>التخصص</label>
                                                <Select name={'major'}
                                                        onChange={selectedOption => {
                                                            setchange(true)
                                                            setFieldValue("major", selectedOption)
                                                        }}
                                                        onFocus={() => {
                                                            setFieldTouched("major")
                                                        }}
                                                        value={values.major}
                                                        isDisabled={!(resumeData && resumeData.specialtyOptions.length > 0)}
                                                        options={resumeData ? resumeData.specialtyOptions : []}
                                                        styles={errors.major && touched.major ? ErrorStyles : customStyles}
                                                        placeholder={'أختر تخصصك'}/>
                                                <ErrorMessage name="major" className={style.TextError} component="div"/>

                                            </div>
                                            <div className={'col-12 col-lg-6 py-2'}style={{boxSizing: 'border-box'}}>
                                                <label className={'text-white mb-2'}>مستوي التعليم</label>
                                                <Select name={'education'}
                                                        onChange={selectedOption => {
                                                            setchange(true)
                                                            setFieldValue("education", selectedOption)
                                                        }}
                                                        onFocus={() => {
                                                            setFieldTouched("education")
                                                        }}
                                                        value={values.education}
                                                        options={resumeData ? resumeData.eduOptions : []}
                                                        styles={errors.education && touched.education ? ErrorStyles : customStyles}
                                                        placeholder={'اختر مؤهلك'}/>
                                                <ErrorMessage name="education" className={style.TextError}
                                                              component="div"/>

                                            </div>
                                            {user && user.gender === "ذكر" ? (
                                                    <div className={'col-12 col-lg-6 py-2'} style={{boxSizing: 'border-box'}}>
                                                        <label className={'text-white mb-2'}>الخدمة العسكرية</label>
                                                        <Select name={'military'}
                                                                onChange={selectedOption => {
                                                                    setchange(true)
                                                                    setFieldValue("military", selectedOption)
                                                                }}
                                                                onFocus={() => {
                                                                    setchange(true)
                                                                    setFieldTouched("military")
                                                                }}
                                                                value={values.military}
                                                                options={resumeData && resumeData.militaryOptions ? resumeData.militaryOptions : []}
                                                                styles={errors.military && touched.military ? ErrorStyles : customStyles}
                                                                placeholder={'اختر موقفك من التجنيد'}/>
                                                        <ErrorMessage name="military" className={style.TextError}
                                                                      component="div"/>

                                                    </div>) : ""}
                                            <div className={'col-12 col-lg-6 py-2'} style={{boxSizing: 'border-box'}}>
                                                <label className={'text-white mb-2'}>الحالة الاجتماعية</label>
                                                <Select name={'socialstatus'}
                                                        onChange={selectedOption => {
                                                            setchange(true)
                                                            setFieldValue("socialstatus", selectedOption)
                                                        }}
                                                        onFocus={() => {
                                                            setFieldTouched("socialstatus")
                                                        }}
                                                        value={values.socialstatus}
                                                        options={resumeData ? resumeData.socialOptions : []}
                                                        styles={errors.socialstatus && touched.socialstatus ? ErrorStyles : customStyles}
                                                        placeholder={'الحالة الاجتماعية'}/>
                                                <ErrorMessage name="socialstatus" className={style.TextError}
                                                              component="div"/>

                                            </div>
                                            <div style={{boxSizing: 'border-box'}} className={user && user.gender === "ذكر" ? 'col-12 col-lg-6 py-2' : 'col-12 py-2'}>
                                                <label htmlFor={'desc'} className={'text-white d-block mb-2'}>وصف
                                                    (خبرات/عمل/تدريب)</label>
                                                <textarea id={'descs'}
                                                          onChange={e => {
                                                              setchange(true)
                                                              setFieldValue("desc", e.target.value)
                                                          }}
                                                          onFocus={() => {
                                                              setFieldTouched("desc")
                                                          }}
                                                          name={'desc'} value={`${values.desc}`}
                                                          className={'w-100 form-control ' + style.textarea + ` ${errors.desc && touched.desc ? style.textareaerror : ""}`}
                                                          placeholder={'من فضلك قم بكتابة الوصف الخاص بك'}
                                                          style={{boxSizing: 'border-box'}}
                                                          />
                                                <ErrorMessage name="desc" className={style.TextError} component="div"/>

                                            </div>
                                            <div className={'col-12 d-flex justify-content-center'}>
                                                <label htmlFor="CV" className={'text-white'}>
                                                    السيرة الذاتيه
                                                    <div className={style.filedrag + ` ${errors.CV && touched.CV ? style.filedragError : ""}`}
                                                         style={{backgroundImage: `url(${errors.CV && touched.CV ? cvIconerror : CV || values.CV ? null : cvIcon})`}}>

                                                        {
                                                            CV || values.CV ? (
                                                                    <div className={'w-100 h-100 d-flex flex-column p-2'} style={{boxSizing: 'border-box'}}>
                                                                        <div title={'تعديل السيرة الذاتيه'}
                                                                             className={'d-flex justify-content-end '}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                                 version="1.1"
                                                                                 width="25" height="25" x="0" y="0"
                                                                                 viewBox="0 0 8.4666664 8.4666664"
                                                                                 className={style.EditIcon}>
                                                                                <g>
                                                                                    <g xmlns="http://www.w3.org/2000/svg"
                                                                                       id="layer1"
                                                                                       transform="translate(0 -288.533)">
                                                                                        <path id="rect3327"
                                                                                              d="m5.4652994 289.74852c-.9101095-.0182-1.8488347.50299-2.1063315 1.67897-1.0480283-.35772-1.9943034.34781-1.8960081 1.47433-.54834732.22165-.93379314.75735-.93379314 1.38699 0 .82909.66745764 1.49655 1.49654944 1.49655h1.817977c-.0005028-.50386-.00156-1.51484-.00156-1.70635l-.4263305.15451c-.309286.13329-.5377246-.25618-.2728516-.49868l.8066691-.78393c.1842447-.18424.4043073-.16311.567418 0l.8066691.78393c.264873.2425.03644.63197-.2728516.49868l-.4263316-.15451v1.70635h1.8164264c.8290917 0 1.4965495-.66746 1.4965495-1.49655 0-.61022-.3622006-1.13186-.883667-1.36529 1.010422-1.96983-.2583736-3.14844-1.5885335-3.175z"
                                                                                              fill="#75b5ff"
                                                                                              data-original="#75b5ff"
                                                                                              className=""></path>
                                                                                        <path
                                                                                                id="path4201"
                                                                                                d="m5.4652994 289.74826c-.050696-.001-.1063442.00075-.1570963.003-1.1624136 1.83195.6340498 3.1719 1.7456298 3.1719 1.010422-1.96984-.2583736-3.14844-1.5885335-3.175z"
                                                                                                fill="#488bff"
                                                                                                data-original="#488bff"></path>
                                                                                    </g>
                                                                                </g>
                                                                            </svg>


                                                                        </div>
                                                                        {errors.CV && touched.CV ? "" : (
                                                                                <div title={'عرض السيرة الذاتيه'}
                                                                                     className={'w-100 h-100 d-flex justify-content-center align-items-center ' + style.cvclick}
                                                                                     onClick={() => getUrl(values.CV)}>
                                                                                    <p className={style.CvName}>{values.CV ? `${user && user.name}-CV` : CV && CV.name}</p>
                                                                                </div>)}

                                                                    </div>
                                                            ) : ('')}

                                                    </div>
                                                    <ErrorMessage name="CV"
                                                                  className={style.TextError + " " + style.cverror}
                                                                  component="div"/>


                                                </label>
                                                <input id={'CV'}


                                                       onChange={async(data) => {
                                                           if(data.target.files) {
                                                               if(data.target.files[0] && data.target.files[0].size / 1024 / 1024 < 2.9) {
                                                                   setchange(true)
                                                                   handleSetCV(data);
                                                                   setFieldValue("CV", data.target.files[0])
                                                               } else {
                                                                   await setFieldValue("CV", "", false)
                                                                   await setFieldTouched("CV");
                                                               }
                                                           }
                                                       }}
                                                       onFocus={() => {
                                                           setFieldTouched("CV")
                                                       }}
                                                       type={'file'} accept={'application/pdf'} className={style.hide}/>


                                            </div>

                                            <div className={'col-12 d-flex justify-content-center mt-4'}>
                                                <button type="submit" disabled={!change} className="btn btn-success">حفظ
                                                    التعديلات
                                                </button>
                                            </div>
                                        </div>
                                    </Form>)}
                        </Formik>
                    </div>
                </>
        )}

    </>)
}

export default Resume;